import CustomConfirmationDialog from '../../../../Dispatch/RouteExecution/DriverPopUp/common/CustomConfirmationDialog';

const ShowInProgressPopup = ({ isUpdateTrailer, onClose }) => {
  return (
    <CustomConfirmationDialog
      title={`${isUpdateTrailer ? 'Update' : 'Add'} trailer in progress`}
      confirmButtonLabel="Ok"
      onConfirm={onClose}>
      {`${isUpdateTrailer ? 'Update' : 'Add'} trailer in progress, Please complete it first.`}
    </CustomConfirmationDialog>
  );
};

export default ShowInProgressPopup;
